// Mini world map — highlights published region associations only.
// Fill is IDENTITY presence (fixed opacity), never intensity/strength.
import React, { useEffect, useMemo, useState } from "react";
import { geoNaturalEarth1, geoPath } from "d3-geo";

const REGION_TO_CONTINENT = {
    north_america: "North America", south_america: "South America", europe: "Europe",
    africa: "Africa", asia: "Asia", oceania: "Oceania",
};

export const RegionMiniMap = ({ geoKeys, color = "hsl(var(--accent))", height = 170 }) => {
    const [features, setFeatures] = useState(null);
    useEffect(() => {
        let c = false;
        fetch("/geo/continents.json").then((r) => r.json()).then((d) => { if (!c) setFeatures(d.features); }).catch(() => {});
        return () => { c = true; };
    }, []);
    const active = useMemo(() => new Set((geoKeys || []).map((k) => REGION_TO_CONTINENT[k]).filter(Boolean)), [geoKeys]);
    const pathFor = useMemo(() => geoPath(geoNaturalEarth1().scale(158).translate([480, 250])), []);
    return (
        <svg viewBox="70 8 820 400" style={{ maxHeight: height }} className="w-full select-none" role="img" aria-label="Region-linked observed activity map">
            {(features || []).map((f, i) => (
                <path key={i} d={pathFor(f)}
                      fill={active.has(f.properties.continent) ? color.replace(")", " / 0.5)") : "hsl(var(--line) / 0.4)"}
                      stroke="hsl(var(--surface) / 0.6)" strokeWidth={0.3} />
            ))}
        </svg>
    );
};
